import { Box, Grid, useMediaQuery, useTheme } from '@mui/material'
import { User } from '__generated__/graphql'
import HeaderLabeledData from 'shared/components/HeaderLabeledData'
import SharedWithAvatars from 'shared/components/SharedWithAvatars'

export interface DetailsRowProps {
    sharedRecruiters?: Pick<User, 'id' | 'preferredName' | 'profileImageKey'>[]
    sharedClients?: Pick<User, 'id' | 'preferredName' | 'profileImageKey'>[]
    positions?: string[]
    startDateLabel?: string
    officeLocations?: string[]
    industries?: string[]
    company?: string
    sectors?: string[]
    hideOnShrink?: boolean
    createdAt?: string
    createdBy?: string
}
const DetailsRow: React.FC<DetailsRowProps> = ({
    sharedRecruiters,
    sharedClients,
    positions,
    startDateLabel,
    officeLocations,
    industries,
    hideOnShrink = true,
    sectors,
}) => {
    const theme = useTheme()
    // Combine media queries into a single object
    const screenSize = {
        isSmScreen: useMediaQuery(theme.breakpoints.down('sm')),
        isMdScreen: useMediaQuery(theme.breakpoints.down('md')),
        isLgScreen: useMediaQuery(theme.breakpoints.down('lg')),
        isXlScreen: useMediaQuery(theme.breakpoints.down('xl')),
    }

    //return hideOnShrink ? hidingDetailsRow() : wrappingDetailsRows()
    // Define the items to render
    const items = [
        {
            component: (
                <SharedWithAvatars
                    label="Internal Users"
                    users={sharedRecruiters}
                />
            ),
            show: true, // Always show
        },
        {
            component: (
                <HeaderLabeledData label="Titles" data={positions ?? []} />
            ),
            show: true, // Always show
        },
        {
            component: (
                <HeaderLabeledData
                    label="Start Date"
                    data={[startDateLabel || '']}
                />
            ),
            show: !hideOnShrink || (hideOnShrink && !screenSize.isSmScreen),
        },
        {
            component: (
                <HeaderLabeledData
                    label="Location"
                    data={officeLocations || []}
                />
            ),
            show: !hideOnShrink || (hideOnShrink && !screenSize.isLgScreen),
        },
        {
            component: (
                <HeaderLabeledData label="Industry" data={industries || []} />
            ),
            show: !hideOnShrink || (hideOnShrink && !screenSize.isLgScreen),
        },
        {
            component: (
                <HeaderLabeledData label="Sector" data={sectors ?? []} />
            ),
            show: !hideOnShrink || (hideOnShrink && !screenSize.isXlScreen),
        },
        {
            component: (
                <SharedWithAvatars label="Shared with" users={sharedClients} />
            ),
            show: !hideOnShrink || (hideOnShrink && !screenSize.isXlScreen),
        },
    ]

    return (
        <Box marginLeft={-2}>
            <Grid
                container
                rowSpacing={0}
                columnSpacing={4}
                alignItems="flex-start"
                justifyContent="flex-start"
            >
                {items
                    .filter((item) => item.show) // Only render items that should be shown
                    .map((item, index) => (
                        <Grid
                            item
                            key={index}
                            alignContent={'start'}
                            style={{ alignSelf: 'start' }}
                        >
                            {item.component}
                        </Grid>
                    ))}
            </Grid>
        </Box>
    )
}

export default DetailsRow
